(function($) {
    'use strict';

    $.Dropdown = function() {
        //  Settings
        this.settings = {
            btn: 'dropdown-link'
        };

        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            dropdown: '.dropdown',
            dropdownLink: '.dropdown a',
            dropdownContent: '.dropdown-content',
            loader: '.loader-logo'
        };

        // Init
        this.init();
    };
    $.Dropdown.prototype = {
        /**
         * Init Dropdown
         */
        init: function() {
            var self = this;
            self.bindEvents();
        },
        /**
         * Bind all dropdown events
         */
        bindEvents: function() {
            var self = this;

            // Init open
            self.elements.body.on('click', self.selectors.dropdownLink+':not([data-event])', {self: self}, self.toggle);
            self.elements.body.on('mouseenter', self.selectors.dropdownLink+'[data-event="mouseenter"]', {self: self}, self.toggle);

            // Init close
            self.elements.body.on('click', {self: self}, self.close);
        },

        /**
         * Show/hide  dropdown content
         * @param event
         * @returns {boolean}
         */
        toggle: function(event) {
            var self = event.data.self;

            // Close all dropdown
            $(self.selectors.dropdown).removeClass('active');
            $(self.selectors.dropdownContent).addClass('hide');

            $(this).parent().toggleClass('active');
            var content = $(this).siblings();
            content.toggleClass('hide');

            if (content.is(':empty')) {
                // Call Ajax
                self.loading(content);
                var route  = content.data('route');
                var params = content.data('params');

                if (undefined != route && undefined != params) {
                    MyFacture.post(route, params, function(data) {
                        content.html(data);
                    }, "html");
                }
            }

            if ($(this).hasClass(self.settings.btn)) {
                return false;
            }
        },
        /**
         * Close dropdown content
         * @param event
         */
        close: function(event) {
            var self = event.data.self;

            $(self.selectors.dropdown).removeClass('active');
            $(self.selectors.dropdownContent).addClass('hide');
        },
        /**
         * Show/hide loader
         * @param content
         * @param show
         */
        loading: function(content, show) {
            var self = this;
            var show = (undefined == show) ? true : show;
            if (show) {
                var loading = MyWindow.getLoader();
                content.html(loading);
            } else {
                content.find(self.selectors.loader).remove();
            }
        }
    };

    $.FormToggle = function() {
        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            link: '*[data-form-toggle="form-toggle"]'
        };

        // Init
        this.init();
    };
    $.FormToggle.prototype = {
        init: function() {
            var self = this;
            self.bindEvents();
        },
        bindEvents: function() {
            var self = this;

            self.elements.body.on('click', self.selectors.link, {self: self}, self.toggle);
            $(self.selectors.link).each(function(i) {
                $(this).addClass('form-toggle-off');
                if ($(this).find('input[type="checkbox"]').is(':checked')) {
                    $(this).toggleClass('form-toggle-on form-toggle-off');
                }
            });
        },
        toggle: function(event) {
            event.preventDefault();
            var self     = event.data.self;
            var checkbox = $(this).find('input[type="checkbox"]');
            
            $(this).toggleClass('form-toggle-on form-toggle-off');
            checkbox.prop("checked", !checkbox.prop("checked"));
        }
    };

    $.ButtonDropdown = function() {
        //  Settings
        this.settings = {
            btn: 'btn'
        };

        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            dropdown: '.btn-dropdown',
            dropdownLink: '.btn-dropdown>a',
            dropdownMenu: '.btn-dropdown-menu'
        };

        // Init
        this.init();
    };
    $.ButtonDropdown.prototype = {
        init: function() {
            var self = this;
            self.bindEvents();
        },
        bindEvents: function() {
            var self = this;

            self.elements.body.on('click', self.selectors.dropdownLink, {self: self}, self.toggle);
            self.elements.body.on('click', {self: self}, self.close);
        },
        toggle: function(event) {
            var self = event.data.self;

            // Close all dropdown
            $(self.selectors.dropdown).removeClass('active');
            $(self.selectors.dropdownMenu).addClass('hide');

            $(this).parent().toggleClass('active');
            $(this).siblings().toggleClass('hide');

            if ($(this).hasClass(self.settings.btn)) {
                return false;
            }
        },
        close: function(event) {
            var self = event.data.self;

            $(self.selectors.dropdown).removeClass('active');
            $(self.selectors.dropdownMenu).addClass('hide');
        }
    };

    $.Collapse = function() {
        // Settings
        this.settings = {
            active: 'collapse-active',
            toggleText: 'data-toggle-text'
        };

        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            link: '*[data-toggle="collapse"]',
            content: '.collapse'
        };

        // Init
        this.init();
    };
    $.Collapse.prototype = {
        init: function() {
            var self = this;
            self.bindEvents();
        },
        bindEvents: function() {
            var self = this;

            self.elements.body.on('click', self.selectors.link, {self: self}, self.toggle);
        },
        toggle: function(event) {
            event.preventDefault();

            var self    = event.data.self;
            var element = $(this).attr('href');
            $(this).toggleClass(self.settings.active);
            self.elements.body.find(element).toggleClass('show');

            if ($(this).attr(self.settings.toggleText)) {
                var text = $(this).text();
                $(this).text($(this).attr(self.settings.toggleText));
                $(this).attr(self.settings.toggleText, text);
            }
        }
    };

    $.FakeLoader = function() {
        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            btn: 'a.btn-loading'
        };

        // Init
        this.init();
    };
    $.FakeLoader.prototype = {
        init: function() {
            var self = this;
            self.bindEvents();
        },
        bindEvents: function() {
            var self = this;
            self.elements.body.on('click', self.selectors.btn, function() {
                MyFacture.startWait();
            });
        }
    };

    $.Toggle = function() {
        // Settings
        this.settings = {
            active: 'active'
        };

        // Elements
        this.elements = {
            body: $('body')
        };

        // Selectors
        this.selectors = {
            link: '*[data-toggle="toggle"] a.btn-default'
        };

        // Init
        this.init();
    };
    $.Toggle.prototype = {
        init: function() {
            var self = this;
            self.bindEvents();
        },
        bindEvents: function() {
            var self = this;

            self.elements.body.on('click', self.selectors.link, {self: self}, self.toggle);
        },
        toggle: function(event) {
            event.preventDefault();
            var self         = event.data.self;
            var current      = $(this);
            var other        = $(this).siblings();
            var currentClass = current.attr('class');
            var otherClass   = other.attr('class');

            $(this).removeClass(currentClass).addClass(otherClass+' '+self.settings.active);
            $(this).siblings().removeClass(otherClass).addClass(currentClass);

            self.elements.body.find(current.attr('href')).toggleClass('hide');
            self.elements.body.find(other.attr('href')).toggleClass('hide');
        }
    };

    $(document).ready(function() {
        new $.Dropdown();
        new $.ButtonDropdown();
        new $.Toggle();
        new $.FormToggle();
        new $.Collapse();
        new $.FakeLoader();
    });
})(jQuery);